"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryLater = exports.SqsNS = void 0;
var SqsNS;
(function (SqsNS) {
    SqsNS.SQS_SERVICE_ID = Symbol.for("SqsService");
    let EventCompressionType;
    (function (EventCompressionType) {
        EventCompressionType["NONE"] = "none";
        EventCompressionType["KEYS"] = "keys";
        EventCompressionType["GZIP"] = "gzip";
    })(EventCompressionType = SqsNS.EventCompressionType || (SqsNS.EventCompressionType = {}));
})(SqsNS = exports.SqsNS || (exports.SqsNS = {}));
class RetryLater {
    constructor(seconds) {
        this.seconds = seconds;
        Object.setPrototypeOf(this, RetryLater.prototype);
    }
}
exports.RetryLater = RetryLater;
//# sourceMappingURL=sqs.types.js.map